import React from 'react';
import { IonMenuButton } from '@ionic/react';

export default () => <IonMenuButton slot="end" menu="primary" autoHide={false} />;
